import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { MapSearchBoxProps } from './types';

const useMapSearchBoxStyles = makeStyles(({ spacing, palette, shadows }) => {
  return createStyles({
    searchBoxWrapper: {
      position: 'absolute',
      top: ({ searchBoxPosition, topOffset }: MapSearchBoxProps) =>
        searchBoxPosition === 'top-right' || searchBoxPosition === 'top-left'
          ? `${(topOffset ?? 0) + 10}px`
          : 'unset',
      bottom: ({ searchBoxPosition }: MapSearchBoxProps) =>
        searchBoxPosition === 'bottom-right' || searchBoxPosition === 'bottom-left'
          ? '10px'
          : 'unset',
      right: ({ searchBoxPosition }: MapSearchBoxProps) =>
        searchBoxPosition === 'top-right' || searchBoxPosition === 'bottom-right'
          ? '10px'
          : 'unset',
      left: ({ searchBoxPosition }: MapSearchBoxProps) =>
        searchBoxPosition === 'top-left' || searchBoxPosition === 'bottom-left' ? '10px' : 'unset',
      display: 'flex',
      flexDirection: 'column',
      width: '20%',
      minWidth: spacing(50),
      maxHeight: '70%',
      overflow: 'hidden',
    },
    listItemsWrapper: {
      borderRadius: spacing(),
      width: '100%',
      margin: `${spacing(2)} 0`,
      backgroundColor: palette.common.white,
      color: palette.common.black,
      boxShadow: shadows[3],
      maxHeight: 'inherit',
      overflowY: 'auto',
    },
  });
});

export default useMapSearchBoxStyles;
